module.exports = __webpack_public_path__ + "img/img09.232a4256.png";